import 'datejs'
import React, { Component } from 'react'
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import LogoImg from '../../../images/logo_PGACOACH.svg'
import theme from '../../theme'
import { Link } from '../Links'
import { cross } from '../Svg/elements'
import {
  links,
  linksMobile,
  LinksContainer,
  handleSignInClick
} from './navLinks'
import {
  AsideNavList,
  AsideWrapper,
  CrossWrapper,
  HamburgerWrapper,
  Logo,
  NavList,
  NavWrapper,
  SignIn,
  StyledMenuWrapper,
  SvgButtonWrapper,
  TopSide,
  NavBarSubtitle
} from './styles'
import styled from 'styled-components'
import { FaArrowRight } from 'react-icons/fa'

export const CustomDropdownToggle = styled(DropdownToggle)`
  padding: 12px 20px !important;
  background: ${theme.colors.gold} !important;
  box-shadow: none;
  &:after {
    margin-left: 0.5em !important;
    vertical-align: 0.1em !important;
  }
`

export const NavBarDropdown = styled.div`
  align-items: center;
  display: flex;
  text-align: center;
  flex-direction: column;
  width: 300px;
  @media (min-width: 600px) {
    display: none;
  }
`

export default class NavBarV2 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      isDropdownOpen: false,
      dropdownDirection: 'down'
    }
    this.toggleStateHandler = this.toggleStateHandler.bind(this)
    this.toggleDropdownHandler = this.toggleDropdownHandler.bind(this)
  }

  toggleStateHandler () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  toggleDropdownHandler () {
    this.setState({
      isDropdownOpen: !this.state.isDropdownOpen,
      dropdownDirection: this.state.dropdownDirection === 'down' ? 'up' : 'down'
    })
  }

  render () {
    return (
      <NavWrapper>
        <TopSide>
          <Link url='/' aria-label='PGA Coach'>
            <Logo alt='Logo' src={LogoImg} />
          </Link>
          <NavList>
            <LinksContainer
              padding='0 15px'
              color={theme.colors.white}
              links={links}
            />
          </NavList>
          <SignIn>
            <ButtonDropdown
              isOpen={this.state.isDropdownOpen}
              toggle={this.toggleDropdownHandler}
              direction={this.state.dropdownDirection}
            >
              <CustomDropdownToggle caret>Sign In</CustomDropdownToggle>
              <StyledMenuWrapper>
                <DropdownMenu right>
                  {linksMobile.map(({ title, url }, index) => (
                    <div key={title}>
                      <DropdownItem onClick={() => handleSignInClick(title)}>
                        <a href={url} target='_blank' rel='noopener noreferrer'>
                          {title} <FaArrowRight />
                        </a>
                      </DropdownItem>
                      {index < linksMobile.length - 1 ? (
                        <DropdownItem divider />
                      ) : null}
                    </div>
                  ))}
                </DropdownMenu>
              </StyledMenuWrapper>
            </ButtonDropdown>
          </SignIn>
          <HamburgerWrapper>
            <SvgButton handler={this.toggleStateHandler} />
          </HamburgerWrapper>
        </TopSide>
        <Aside
          isOpen={this.state.isOpen}
          svg={cross}
          handler={this.toggleStateHandler}
        />
      </NavWrapper>
    )
  }
}
export const SvgButton = ({ svg, handler, isOpen }) => (
  <SvgButtonWrapper onClick={handler} aria-label='Open navigation'>
    {!isOpen ? (
      <svg
        width='40'
        height='40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5 20h30M5 10h30M5 30h30'
          stroke='#fff'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ) : (
      <svg
        width='30'
        height='30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='m1.742 28.715 26.516-27.43M1.742 1.285l26.516 27.43'
          stroke='#00234B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    )}
  </SvgButtonWrapper>
)

export const Aside = ({ isOpen, svg, handler }) => {
  return (
    <AsideWrapper active={isOpen}>
      <CrossWrapper>
        <SvgButton svg={svg} handler={handler} isOpen={isOpen} />
      </CrossWrapper>
      <AsideNavList>
        <LinksContainer
          padding='20px 0'
          color={theme.colors.navy}
          links={links}
        />
        <NavBarDropdown>
          <NavBarSubtitle>
            <span>Sign In</span>
          </NavBarSubtitle>
          <LinksContainer
            padding='20px 0'
            color={theme.colors.navy}
            links={linksMobile}
            handleLinkClick={handleSignInClick}
          />
        </NavBarDropdown>
      </AsideNavList>
    </AsideWrapper>
  )
}
